/* eslint-disable custom/no-restricted-translation-jsx-untranslated-children-text */
import React from 'react';

import { Typography } from '@mui/material';

import { useIntl } from '@kamernet/core/Intl';
import { Locale } from '@kamernet/core/Intl/types';
import { NavLink } from '@kamernet/core/Routing/NavLink';
import { ROUTES } from '@kamernet/core/Routing';

import styles from './Content.module.css';

export const ContentCountryStudio = () => {
  const { locale } = useIntl();

  return locale === Locale.en ? (
    <React.Fragment>
      <Typography variant="h1" className={styles.title}>
        Studios for rent in Netherlands
      </Typography>
      <Typography variant="body1" className={styles.paragraph}>
        {`Are you searching for a studio for rent in Netherlands? Look no
            further! Kamernet offers a comprehensive selection of studio
            apartments in Netherlands for both short-term and long-term. Whether
            you're a student, a young professional or a couple seeking a cozy
            living space, we have the ideal studio to suit your needs.`}
      </Typography>
      <Typography variant="h3" className={styles.title}>
        Why choose a studio apartment in Netherlands?
      </Typography>
      <Typography variant="body1" className={styles.paragraph}>
        Studio apartments are an excellent choice for individuals or couples who
        prioritise convenience, affordability, and functionality. With a compact
        layout that maximises space efficiency, studio apartments offer
        everything you need in one cohesive living area including a bedroom,
        living room, kitchen and a private bathroom as well.
      </Typography>
      <Typography variant="body1" className={styles.paragraph}>
        Renting a studio apartment in the Netherlands has never been easier.
        Simply use our extensive search filters to narrow down your options and
        connect directly with landlords to secure your new home. With our
        user-friendly platform, simply browse through our extensive selection of
        listings and filter by price, location, and amenities to find the ideal
        rental that fits your lifestyle and budget.
      </Typography>
      <Typography variant="body1" className={styles.paragraph}>
        {`At Kamernet, we are committed to providing a seamless and
            stress-free rental experience for both tenants and landlords. Don't
            miss out on the opportunity to find your perfect studio apartment
            for rent in Netherlands. Start your search today and take the first
            step towards finding your new home in The Netherlands`}
      </Typography>
      <Typography variant="h3" className={styles.title}>
        Useful Links:
      </Typography>
      <NavLink.Anchor
        href={ROUTES.ListingSearchCity.url(
          { typeAndCity: 'studio-almere' },
          Locale.en,
        )}
      >
        Almere studios
      </NavLink.Anchor>
      |
      <NavLink.Anchor
        href={ROUTES.ListingSearchCity.url(
          { typeAndCity: 'studio-nijmegen' },
          Locale.en,
        )}
      >
        Nijmegen studios
      </NavLink.Anchor>
      |
      <NavLink.Anchor
        href={ROUTES.ListingSearchCity.url(
          { typeAndCity: 'studio-hilversum' },
          Locale.en,
        )}
      >
        Hilversum studios
      </NavLink.Anchor>
      |
      <NavLink.Anchor
        href={ROUTES.ListingSearchCity.url(
          { typeAndCity: 'studio-eindhoven' },
          Locale.en,
        )}
      >
        Eindhoven studios
      </NavLink.Anchor>
      |
      <NavLink.Anchor
        href={ROUTES.ListingSearchCity.url(
          { typeAndCity: 'studio-hoofddorp' },
          Locale.en,
        )}
      >
        Hoofddorp studios
      </NavLink.Anchor>
      |
      <NavLink.Anchor
        href={ROUTES.ListingSearchCity.url(
          { typeAndCity: 'studio-zaandam' },
          Locale.en,
        )}
      >
        Zaandam studios
      </NavLink.Anchor>
      |
      <NavLink.Anchor
        href={ROUTES.ListingSearchCity.url(
          { typeAndCity: 'studio-arnhem' },
          Locale.en,
        )}
      >
        Arnhem studios
      </NavLink.Anchor>
      |
      <NavLink.Anchor
        href={ROUTES.ListingSearchCity.url(
          { typeAndCity: 'studio-tilburg' },
          Locale.en,
        )}
      >
        Tilburg studios
      </NavLink.Anchor>
      |
      <NavLink.Anchor
        href={ROUTES.ListingSearchCity.url(
          { typeAndCity: 'studio-enschede' },
          Locale.en,
        )}
      >
        Enschede studios
      </NavLink.Anchor>
      |
      <NavLink.Anchor
        href={ROUTES.ListingSearchCity.url(
          { typeAndCity: 'studio-amersfoort' },
          Locale.en,
        )}
      >
        Amersfoort studios
      </NavLink.Anchor>
      |
      <NavLink.Anchor
        href={ROUTES.ListingSearchCity.url(
          { typeAndCity: 'studio-zeist' },
          Locale.en,
        )}
      >
        Zeist studios
      </NavLink.Anchor>
      |
      <NavLink.Anchor
        href={ROUTES.ListingSearchCity.url(
          { typeAndCity: 'studio-breda' },
          Locale.en,
        )}
      >
        Breda studios
      </NavLink.Anchor>
      |
      <NavLink.Anchor
        href={ROUTES.ListingSearchCity.url(
          { typeAndCity: 'studio-maastricht' },
          Locale.en,
        )}
      >
        Maastricht studios
      </NavLink.Anchor>
      |
      <NavLink.Anchor
        href={ROUTES.ListingSearchCity.url(
          { typeAndCity: 'studio-nieuwegein' },
          Locale.en,
        )}
      >
        Nieuwegein studios
      </NavLink.Anchor>
      |
      <NavLink.Anchor
        href={ROUTES.ListingSearchCity.url(
          { typeAndCity: 'studio-schiedam' },
          Locale.en,
        )}
      >
        Schiedam studios
      </NavLink.Anchor>
    </React.Fragment>
  ) : (
    <React.Fragment>
      <Typography variant="h1" className={styles.title}>
        Studio te huur in Nederland
      </Typography>
      <Typography variant="body1" className={styles.paragraph}>
        {`Ben je op zoek naar een studio te huur in Nederland? Zoek dan niet
            verder! Kamernet biedt een uitgebreide selectie studio's in
            Nederland voor zowel korte als lange termijn. Of je nu een student
            bent, een young professional of een koppel op zoek naar een
            gezellige woonruimte, wij hebben de ideale studio die aan jouw
            wensen voldoet.`}
      </Typography>
      <Typography variant="h3" className={styles.title}>
        Waarom kiezen voor een studio in Nederland?
      </Typography>
      <Typography variant="body1" className={styles.paragraph}>
        Studio-appartementen zijn een uitstekende keuze voor individuen of
        koppels die gemak, betaalbaarheid en functionaliteit belangrijk vinden.
        Met een compacte indeling die de ruimte optimaal benut, bieden
        studio-appartementen alles wat je nodig hebt in één gezamenlijke
        woonruimte, waaronder een slaapkamer, woonkamer, kitchenette en vaak een
        eigen badkamer.
      </Typography>
      <Typography variant="body1" className={styles.paragraph}>
        Het huren van een studio in Nederland is nog nooit zo eenvoudig geweest.
        Gebruik onze uitgebreide zoekfilters om je opties te verfijnen en kom
        direct in contact met verhuurders om je nieuwe huis te vinden. Dankzij
        ons gebruiksvriendelijke platform hoef je alleen maar door ons
        uitgebreide aanbod te zoeken en te filteren op prijs, locatie en
        voorzieningen om de ideale huurwoning te vinden die bij jouw levensstijl
        en budget past.
      </Typography>
      <Typography variant="body1" className={styles.paragraph}>
        Bij Kamernet zijn we toegewijd aan het bieden van een soepele en
        stressvrije huurervaring voor zowel huurders als verhuurders. Mis de
        kans niet om je perfecte studio te huur in Nederland te vinden. Begin
        vandaag nog met zoeken en zet de eerste stap naar je nieuwe thuis in
        Nederland.
      </Typography>
      <Typography variant="h3" className={styles.title}>
        Handige links:
      </Typography>
      <NavLink.Anchor
        href={ROUTES.ListingSearchCity.url(
          { typeAndCity: 'studio-almere' },
          Locale.nl,
        )}
      >
        Studio Almere
      </NavLink.Anchor>
      |
      <NavLink.Anchor
        href={ROUTES.ListingSearchCity.url(
          { typeAndCity: 'studio-nijmegen' },
          Locale.nl,
        )}
      >
        Studio Nijmegen
      </NavLink.Anchor>
      |
      <NavLink.Anchor
        href={ROUTES.ListingSearchCity.url(
          { typeAndCity: 'studio-hilversum' },
          Locale.nl,
        )}
      >
        Studio Hilversum
      </NavLink.Anchor>
      |
      <NavLink.Anchor
        href={ROUTES.ListingSearchCity.url(
          { typeAndCity: 'studio-eindhoven' },
          Locale.nl,
        )}
      >
        Studio Eindhoven
      </NavLink.Anchor>
      |
      <NavLink.Anchor
        href={ROUTES.ListingSearchCity.url(
          { typeAndCity: 'studio-hoofddorp' },
          Locale.nl,
        )}
      >
        Studio Hoofddorp
      </NavLink.Anchor>
      |
      <NavLink.Anchor
        href={ROUTES.ListingSearchCity.url(
          { typeAndCity: 'studio-zaandam' },
          Locale.nl,
        )}
      >
        Studio Zaandam
      </NavLink.Anchor>
      |
      <NavLink.Anchor
        href={ROUTES.ListingSearchCity.url(
          { typeAndCity: 'studio-arnhem' },
          Locale.nl,
        )}
      >
        Studio Arnhem
      </NavLink.Anchor>
      |
      <NavLink.Anchor
        href={ROUTES.ListingSearchCity.url(
          { typeAndCity: 'studio-tilburg' },
          Locale.nl,
        )}
      >
        Studio Tilburg
      </NavLink.Anchor>
      |
      <NavLink.Anchor
        href={ROUTES.ListingSearchCity.url(
          { typeAndCity: 'studio-enschede' },
          Locale.nl,
        )}
      >
        Studio Enschede
      </NavLink.Anchor>
      |
      <NavLink.Anchor
        href={ROUTES.ListingSearchCity.url(
          { typeAndCity: 'studio-amersfoort' },
          Locale.nl,
        )}
      >
        Studio Amersfoort
      </NavLink.Anchor>
      |
      <NavLink.Anchor
        href={ROUTES.ListingSearchCity.url(
          { typeAndCity: 'studio-zeist' },
          Locale.nl,
        )}
      >
        Studio Zeist
      </NavLink.Anchor>
      |
      <NavLink.Anchor
        href={ROUTES.ListingSearchCity.url(
          { typeAndCity: 'studio-breda' },
          Locale.nl,
        )}
      >
        Studio Breda
      </NavLink.Anchor>
      |
      <NavLink.Anchor
        href={ROUTES.ListingSearchCity.url(
          { typeAndCity: 'studio-maastricht' },
          Locale.nl,
        )}
      >
        Studio Maastricht
      </NavLink.Anchor>
      |
      <NavLink.Anchor
        href={ROUTES.ListingSearchCity.url(
          { typeAndCity: 'studio-nieuwegein' },
          Locale.nl,
        )}
      >
        Studio Nieuwegein
      </NavLink.Anchor>
      |
      <NavLink.Anchor
        href={ROUTES.ListingSearchCity.url(
          { typeAndCity: 'studio-schiedam' },
          Locale.nl,
        )}
      >
        Studio Schiedam
      </NavLink.Anchor>
    </React.Fragment>
  );
};
